export const PERFORMANCE_OPTIONS_COLOR = "#b399a2";
